import React, { useState, useContext, useRef, Suspense, useEffect, useCallback } from "react"
import { Canvas } from "react-three-fiber"
import { Map as MapCanvas } from "./Map/Map"
import ModalPoint from "./Map/ModalPoint"
import ModalEdge from "./Map/ModalEdge"
import ModalReset from "./Map/ModalReset"
import ModalArea from "./Map/ModalArea"
import ModalMap from "./Map/ModalMap"
import ModalDelete from "./Map/ModalDelete"
import ModalSyncPreview from "./Map/ModalSyncPreview"
import Context from "../../utils/Context"
import { sendTaskToRobot, cancelActions, sendNavInfo, watchRobotPosition } from "../../utils/ROS/ROSFunctions"
import Joystick from "../../components/Joystick"
import OccupancyGridVisualizer from "./Map/OccupancyGridVisualizer"
import ROS from "../../utils/ROS/ROS"
import api from "../../api/api"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave, faSpinner, faLocationArrow, faUndo, faRetweet, faCirclePlus, faMapMarked, faCheck, faTrash, faBan, faVectorSquare, faReply, faShare, faMapPin, faMapSigns, faArrowPointer, faCircleDot, faCopy, faPaste } from "@fortawesome/free-solid-svg-icons"
import ShowMessage from "../../components/ShowMessage"
import CompareArray from "../../components/elements/CompareArray"

export default function Maps() {
  const context = useContext(Context)
  const canvasRef = useRef()
  const modalRef = useRef()
  const orientation = context.orientation
  const [modal, setModal] = useState(false)
  const [typeMap, setTypeMap] = useState(false)
  const [modalData, setModalData] = useState(null)
  const [isMapping, setIsMapping] = useState(false)
  const [hand, setHand] = useState(false)
  const [canvas, setCanvas] = useState(null)
  const [autoSave, setAutoSave] = useState(false)
  const [syncPreview, setSyncPreview] = useState(null)
  const [syncPreparedObjects, setSyncPreparedObjects] = useState(null)
  const [selectedProfileName, setSelectedProfileName] = useState('')
  const selectedMapName = context.selected.map?.name
  const currentRobotId = context.robotInfo?._id

  const c = console.log.bind(document)

  useEffect(() => {
    selectTool('select')
    /*const index = 0
    console.log(c)
    let maps = context.maps.map(m => m.robotId === context.robotInfo._id && m.name === map.name ?
      ({ ...m, active: true })
      : m.robotId === context.robotInfo._id ?
        ({ ...m, active: false })
        :
        (m))

    const map = maps[index]
    console.log(index, map)
    context.actions.setMapIndex(index)
    context.actions.setSelected({ map: { name: map.name, robotId: context.robotInfo._id } })
    context.actions.setHelpers({ ...context.helpers, newItem: true })
    setIsMapping((context.mappingCurrent && context.mappingCurrent.name === map.name) ? context.mappingCurrent?.mapping : false)
    context.actions.setMapObjects(map.objects ? map.objects : {})

    console.log(maps)
    //context.actions.setMaps(maps)*/
  }, [])

  useEffect(() => {
    if (context.endOfMission && context.lastMission === 'map') {
      //exportMaps()
    }
  }, [context.endOfMission])

  useEffect(() => {
    if (autoSave) {
      exportMaps()
    }
  }, [context.changes, autoSave])

  // process mapping feeback --------------------------------------

  useEffect(() => {
    if (context.mappingStatus) {
      setIsMapping((context.mappingCurrent) ? context.mappingCurrent.mapping : true)
    }
  }, [context.mappingStatus])

  // validate nav point name ----------------------------------------------------------------------------

  const savePoint = async () => {
    if (context.selected.tool?._id === 'points') {
      const filtered = context.mapObjects.points?.filter(p => p.name?.indexOf(n => n === modalData.name) > -1)
      console.log('finding point name', filtered, context.mapObjects.points, modalData?.name)

      if (!modalData?.name || (modalData?.name && modalData.name.length < 0)) {
        context.actions.setMessage({ message: "Please add an ID", type: "error" })
        return false

      } else if (filtered.length > 1) {
        context.actions.setMessage({ message: "This ID is already in use", type: "error" })
        return false
      }
    }

    // reset newObject
    if (context.helpers.newObject) context.actions.setHelpers({ ...context.helpers, newObject: false })

    setModalData(null)

    setModal(false)
    context.actions.setMessage({ message: "There are unsaved items", type: "error" })
  }

  // open modals -----------------------------------------------------------

  const openModal = (modalType, data) => {
    if (data) setModalData(data)

    if (modalType) setModal(modalType)

  }

  const locateRobot = () => {
    // (context)
    selectTool('location')
    //setModal('location')
  }

  // convert nav info format -----------------------------------------------

  const convertNavInfo = useCallback((newObjects) => {

    let objects

    if (newObjects) {
      objects = newObjects
    } else {
      objects = context.mapObjects
    }

    let navInfo = { points: [], edges: [], zones: [], no_go: [], map_name: context.selected.map?.name }

    console.log("filling nav info", objects)
    console.log("nav info map name", context.selected.map?.name)

    // fill points info
    Array.isArray(objects.points) && objects.points.forEach(point => {
      navInfo.points.push({ id: point.name, point: point.point })
    })

    // fill edges info
    let fromPoint, toPoint
    Array.isArray(objects.edges) && Array.isArray(objects.points) && objects.edges.forEach(item => {
      fromPoint = objects.points.find(p => p.name.indexOf(item.from) > -1)
      toPoint = objects.points.find(p => p.name.indexOf(item.to) > -1)
      if (fromPoint?.point) fromPoint = fromPoint.point
      if (toPoint?.point) toPoint = toPoint.point
      if (fromPoint && toPoint) {
        const distance = Math.sqrt(Math.pow((toPoint.x - fromPoint.x), 2) + Math.pow((toPoint.y - fromPoint.y), 2))
        navInfo.edges.push({ id1: item.from, id2: item.to, distance: distance, avoid: item.avoid, reversable: item.reversable })
      }
    })

    // fill zones info
    let zone
    Array.isArray(objects.areas) && objects.areas.forEach(item => {
      zone = { name: item.name, polygon: [], max_velocity: item.velocity ? item.velocity : 1, beep: item.beep ? item.beep : false }
      Array.isArray(item.polygon) && item.polygon.forEach((point, i) => {
        if (i < item.polygon.length)
          zone.polygon.push(point.point)
      })
      navInfo.zones.push(zone)
    })

    // fill no_go info
    Array.isArray(objects.no_go) && objects.no_go.forEach(item => {
      zone = { polygon: [] }
      Array.isArray(item.polygon) && item.polygon.forEach(point => {
        zone.polygon.push(point.point)
      })
      navInfo.no_go.push(zone)
    })

    return navInfo
  }, [context.selected])

  const calculateZoneRotation = (angle, x, y, width, height) => {
    let points = [{ x: x, y: y }, { x: x + width, y: y }, { x: x + width, y: y + height }, { x: x, y: y + height }]

    let angleRadian = (angle * Math.PI) / 180

    points[1].x = x + Math.cos(angleRadian) * width
    points[1].y = y - Math.sin(angleRadian) * width

    points[2].x = x + Math.cos(angleRadian) * width + Math.sin(angleRadian) * height
    points[2].y = y - Math.sin(angleRadian) * width + Math.cos(angleRadian) * height

    points[3].x = x + Math.sin(angleRadian) * height
    points[3].y = y + Math.cos(angleRadian) * height

    return points
  }

  // save map --------------------------------------------------------------

  const save = async () => {
    let maps = [...context.maps]
    console.log(context.maps)
    const currentMap = context.maps.find(m => m.name === context.selected.map?.name) || context.maps[context.mapIndex] || {}
    const activeProfileName = resolveActiveProfileName(currentMap, selectedProfileName)
    const resolution = Number.isFinite(Number(currentMap?.resolution)) && Number(currentMap?.resolution) > 0
      ? Number(currentMap.resolution)
      : (Number.isFinite(Number(context.mapDimensions?.resolution)) && Number(context.mapDimensions?.resolution) > 0 ? Number(context.mapDimensions.resolution) : 1)
    const originX = Number.isFinite(Number(currentMap?.origin?.x)) ? Number(currentMap.origin.x) : 0
    const originY = Number.isFinite(Number(currentMap?.origin?.y)) ? Number(currentMap.origin.y) : 0
    const mapHeight = Number.isFinite(Number(context.mapDimensions?.height)) ? Number(context.mapDimensions.height) : 0
    const toWorldPoint = (x, y) => ({
      x: x * resolution + originX,
      y: -(y - mapHeight) * resolution + originY,
      z: 2
    })
    validateZone()
    console.log(context.konvaPoints, context.konvaEdges, context.mapObjects, currentMap)
    let newObjects = {}
    let noGoPoints = []
    //let slowPoints = []

    context.konvaPoints.length !== 0 && context.konvaPoints.forEach((point, i) => {
      if (!point || !Number.isFinite(Number(point.x)) || !Number.isFinite(Number(point.y))) return
      if (i === 0) newObjects.points = []
      switch (point.fill) {
        case 'blue':
          newObjects.points.push({ counter: 'pn-' + (i + 1), name: [point.name], point: toWorldPoint(point.x, point.y) })
          break

        case 'red':
          noGoPoints.push({ counter: 'pf-' + (i + 1), name: point.name, point: toWorldPoint(point.x, point.y) })
          break

        default:
          break
      }
    })

    let noGoAdjacency = {}
    //let slowAdjacency = {}
    let noGoEdges = new Set()
    //let slowEdges = new Set()

    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge, i) => {
      if (i === 0) newObjects.edges = []
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]
      let reverse = true
      if (edge.pointerAtEnding) {
        reverse = false
      }
      if (edge.pointerAtBeginning) {
        reverse = false
        pointA = edge.pointIds[1]
        pointB = edge.pointIds[0]
      }

      switch (edge.stroke) {
        case 'purple':
          newObjects.edges.push({ avoid: true, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'blue':
          newObjects.edges.push({ avoid: false, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'red':
          if (!noGoAdjacency[pointA]) noGoAdjacency[pointA] = []
          if (!noGoAdjacency[pointB]) noGoAdjacency[pointB] = []
          noGoAdjacency[pointA].push(pointB)
          noGoAdjacency[pointB].push(pointA)
          break

        default:
          break
      }
    })

    console.log(noGoPoints, noGoAdjacency)
    let noGoPolygons = []
    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge) => {
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]

      if (edge.stroke === 'red') {
        if (!noGoEdges.has(edgeKey(pointA, pointB))) {
          const polygon = tracePolygon(pointA, noGoEdges, noGoAdjacency)

          noGoPolygons.push(polygon)
        }
      }
    })

    console.log(context.konvaPoints, noGoPoints)

    let finalNoGo = noGoPolygons.map((polygon) => {
      let corners = polygon.map((corner) => {
        let correctCorner = noGoPoints.find((point) => corner === point.name || point.name.includes(corner))
        if (!correctCorner) return null
        return { counter: correctCorner.counter, point: correctCorner.point }
      }).filter(Boolean)

      return { polygon: corners }
    })

    console.log(finalNoGo)

    if (finalNoGo.length !== 0) newObjects.no_go = finalNoGo

    context.konvaZones.length !== 0 && context.konvaZones.forEach((zone, i) => {
      if (i === 0) newObjects.areas = []
      let beep

      switch (zone.stroke) {
        case 'orange':
          beep = false
          break

        case 'hotpink':
          beep = true
          break

        default:
          break
      }

      if (zone.rotation === 0) {
        newObjects.areas.push({
          velocity: zone.velocity,
          beep: beep,
          name: zone.name,
          polygon: [
            { counter: 'pz1-' + (i + 1), point: toWorldPoint(zone.x, zone.y) },
            { counter: 'pz2-' + (i + 1), point: toWorldPoint(zone.x + zone.width * zone.scaleX, zone.y) },
            { counter: 'pz3-' + (i + 1), point: toWorldPoint(zone.x + zone.width * zone.scaleX, zone.y + zone.height * zone.scaleY) },
            { counter: 'pz4-' + (i + 1), point: toWorldPoint(zone.x, zone.y + zone.height * zone.scaleY) }
          ]
        })
      } else {
        let fourPoints = calculateZoneRotation(zone.rotation, zone.x, zone.y, zone.width * zone.scaleX, zone.height * zone.scaleY)

        newObjects.areas.push({
          velocity: zone.velocity,
          beep: beep,
          name: zone.name,
          polygon: [
            { counter: 'pz1-' + (i + 1), point: toWorldPoint(zone.x, zone.y) },
            { counter: 'pz2-' + (i + 1), point: toWorldPoint(fourPoints[1].x, fourPoints[1].y) },
            { counter: 'pz3-' + (i + 1), point: toWorldPoint(fourPoints[2].x, fourPoints[2].y) },
            { counter: 'pz4-' + (i + 1), point: toWorldPoint(fourPoints[3].x, fourPoints[3].y) }
          ]
        })
      }
    })

    console.log(newObjects, context.mapObjects)

    sendNavInfo(convertNavInfo(newObjects), context.selectedRobot.ROS)

    if (context.settings.fmsConnection) {
      await exportMaps(newObjects)
      return
    }

    const newMap = {
      ...context.maps[context.mapIndex],
      objects: newObjects,
      profiles: buildProfilesForSave(context.maps[context.mapIndex], activeProfileName, newObjects)
    }
    delete newMap.profile
    maps[context.mapIndex] = newMap
    context.actions.setMapObjects(newObjects)
    console.log(context.maps, maps)
    context.actions.setMaps(maps)
    context.actions.setMessage({ message: "Saved", type: "success" })
  }

  // save map name ----------------------------------------------------------

  const saveMap = async () => {

    if (!modalData?.mapName || modalData?.mapName === "") {
      context.actions.setMessage({ message: "Please fill map name", type: "error" })
      return false
    }

    const robotId = context.robotInfo?._id
    const searchMap = context.maps.find(m => m.name?.toLowerCase() === modalData.mapName?.toLowerCase() && m.robotId === robotId)
    if (searchMap) {
      context.actions.setMessage({ message: "Map already exists", type: "error" })
      return false
    }

    if (~modalData?.mapName.indexOf('.') || ~modalData?.mapName.indexOf('/') || ~modalData?.mapName.indexOf('\\') || ~modalData?.mapName.indexOf(';') || ~modalData?.mapName.indexOf(':')) {
      context.actions.setMessage({ message: "Please not fill map name with points, slash or backslash", type: "error" })
      return false
    }


    context.actions.setMapObjects({})

    let maps, mapId

    // send map item to FMS
    if (context.settings.fmsConnection) {

      const mapIndex = context.maps.length - 1
      context.actions.setMapIndex(mapIndex)
      maps = context.maps.map(m => m.robotId === robotId ? ({ ...m, active: false }) : m)
      mapId = null

      if (!context.robotInfo) {
        context.actions.setMessage({ message: "Robot not registered on FMS. Please register it with the official name.", type: "error" })
        return false
      }

      console.log(modalData, context.selectedRobot, typeMap, context.mapFeedFull)
      context.actions.setMaps([...maps, { name: modalData.mapName, robot: context.selectedRobot.name, robotId: robotId, active: true, _id: mapId, link: '/maps/' + modalData.mapName + '.png' }])
      context.actions.setMappingCurrent({ name: modalData.mapName, robot: context.selectedRobot.name, robotId: robotId, mapping: isMapping })
      if (context.selectedRobot.ROS === 'ROS2') {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needs_value: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      } else {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needsValue: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      }
      context.actions.setSelected({ map: { name: modalData.mapName, robotId: robotId } })
      setModal(null)
    } else {
      context.actions.setMapIndex(0)

      console.log(modalData, context.selectedRobot, typeMap, context.mapFeedFull)
      context.actions.setMaps([{ name: modalData.mapName, _id: 1, objects: {}, link: '/maps/' + modalData.mapName + '.png' }])
      context.actions.setMappingCurrent({ name: modalData.mapName, robot: context.selectedRobot.name, mapping: isMapping })
      if (context.selectedRobot.ROS === 'ROS2') {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needs_value: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      } else {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needsValue: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      }
      context.actions.setSelected({ map: { name: modalData.mapName } })
      setModal(null)
    }

    // subscribe to map
    if (canvas) {
      console.log("subscribing to map")
      window.mapSubscriber = ROS.subscribeMap(callback, canvas, context, false)
    }
  }


  const getMapOccurrence = (maps, value) => {
    var count = maps.filter((e) => (e.name === value && e.robot === context.robotInfo.name)).length
    var mapsPosition
    var qtd = []

    console.log(count, maps)

    if (count > 1) {
      let newMaps = maps

      newMaps.splice(newMaps.indexOf(value))
      context.actions.setMaps(newMaps)

    } else {
      return true
    }

  }

  // sync fms --------------------------------------------------------------

  const roundCoord = (value) => (typeof value === 'number' ? Number(value.toFixed(3)) : value)

  const normalizePointName = (name) => (Array.isArray(name) ? name[0] : name)

  const buildPointMap = (points = []) => {
    const map = new Map()
    points.forEach((point) => {
      const name = normalizePointName(point.name)
      if (name) map.set(name, point)
    })
    return map
  }

  const pointSignature = (point) => {
    if (!point?.point) return ''
    return `${roundCoord(point.point.x)}|${roundCoord(point.point.y)}`
  }

  const polygonSignature = (polygon = []) => {
    return polygon
      .map((entry) => `${roundCoord(entry.point?.x)}|${roundCoord(entry.point?.y)}`)
      .join(';')
  }

  const buildSyncPreview = (beforeObjects = {}, afterObjects = {}) => {
    const beforePoints = buildPointMap(beforeObjects.points || [])
    const afterPoints = buildPointMap(afterObjects.points || [])
    const allPointNames = new Set([...beforePoints.keys(), ...afterPoints.keys()])

    const pointChanges = []
    allPointNames.forEach((name) => {
      const before = beforePoints.get(name)
      const after = afterPoints.get(name)
      if (!before) {
        pointChanges.push({ name, type: 'added', before: null, after })
      } else if (!after) {
        pointChanges.push({ name, type: 'removed', before, after: null })
      } else if (pointSignature(before) !== pointSignature(after)) {
        pointChanges.push({ name, type: 'updated', before, after })
      }
    })

    const edgeKey = (edge) => `${edge.from}|${edge.to}`
    const edgeSignature = (edge) => `${edge.from}|${edge.to}|${edge.avoid ? 1 : 0}|${edge.reversable ? 1 : 0}`
    const beforeEdges = new Map((beforeObjects.edges || []).map((edge) => [edgeKey(edge), edge]))
    const afterEdges = new Map((afterObjects.edges || []).map((edge) => [edgeKey(edge), edge]))
    const allEdgeKeys = new Set([...beforeEdges.keys(), ...afterEdges.keys()])
    const edgeChanges = { added: [], removed: [], changed: [] }

    allEdgeKeys.forEach((key) => {
      const before = beforeEdges.get(key)
      const after = afterEdges.get(key)
      if (!before && after) edgeChanges.added.push(after)
      else if (before && !after) edgeChanges.removed.push(before)
      else if (before && after && edgeSignature(before) !== edgeSignature(after)) {
        edgeChanges.changed.push({ before, after })
      }
    })

    const zoneSignature = (zone) => {
      const polygon = Array.isArray(zone.polygon) ? zone.polygon : []
      return `${zone.name}|${roundCoord(zone.velocity)}|${zone.beep ? 1 : 0}|${polygonSignature(polygon)}`
    }

    const beforeZones = new Map((beforeObjects.zones || []).map((zone) => [zone.name, zone]))
    const afterZones = new Map((afterObjects.zones || []).map((zone) => [zone.name, zone]))
    const allZoneNames = new Set([...beforeZones.keys(), ...afterZones.keys()])
    const zoneChanges = { added: [], removed: [], changed: [] }

    allZoneNames.forEach((name) => {
      const before = beforeZones.get(name)
      const after = afterZones.get(name)
      if (!before && after) zoneChanges.added.push(after)
      else if (before && !after) zoneChanges.removed.push(before)
      else if (before && after && zoneSignature(before) !== zoneSignature(after)) {
        zoneChanges.changed.push({ before, after })
      }
    })

    const beforeNoGo = new Map((beforeObjects.no_go || []).map((zone, index) => [polygonSignature(zone.polygon || []), { ...zone, index }]))
    const afterNoGo = new Map((afterObjects.no_go || []).map((zone, index) => [polygonSignature(zone.polygon || []), { ...zone, index }]))
    const allNoGoKeys = new Set([...beforeNoGo.keys(), ...afterNoGo.keys()])
    const noGoChanges = { added: [], removed: [] }

    allNoGoKeys.forEach((key) => {
      const before = beforeNoGo.get(key)
      const after = afterNoGo.get(key)
      if (!before && after) noGoChanges.added.push(after)
      else if (before && !after) noGoChanges.removed.push(before)
    })

    return {
      points: pointChanges,
      edges: edgeChanges,
      areas: zoneChanges,
      noGo: noGoChanges
    }
  }

  const buildObjectsForExport = (currentMap) => {
    const safeMap = currentMap || context.maps[context.mapIndex] || {}
    const resolution = Number.isFinite(Number(safeMap?.resolution)) && Number(safeMap?.resolution) > 0
      ? Number(safeMap.resolution)
      : (Number.isFinite(Number(context.mapDimensions?.resolution)) && Number(context.mapDimensions?.resolution) > 0 ? Number(context.mapDimensions.resolution) : 1)
    const originX = Number.isFinite(Number(safeMap?.origin?.x)) ? Number(safeMap.origin.x) : 0
    const originY = Number.isFinite(Number(safeMap?.origin?.y)) ? Number(safeMap.origin.y) : 0
    const mapHeight = Number.isFinite(Number(context.mapDimensions?.height)) ? Number(context.mapDimensions.height) : 0
    const toWorldPoint = (x, y) => ({
      x: x * resolution + originX,
      y: -(y - mapHeight) * resolution + originY,
      z: 2
    })

    let newObjects = {}
    let noGoPoints = []

    context.konvaPoints.length !== 0 && context.konvaPoints.forEach((point, i) => {
      if (!point || !Number.isFinite(Number(point.x)) || !Number.isFinite(Number(point.y))) return
      if (i === 0) newObjects.points = []
      switch (point.fill) {
        case 'blue':
          newObjects.points.push({ counter: 'pn-' + (i + 1), name: [point.name], point: toWorldPoint(point.x, point.y) })
          break

        case 'red':
          noGoPoints.push({ counter: 'pf-' + (i + 1), name: point.name, point: toWorldPoint(point.x, point.y) })
          break

        default:
          break
      }
    })

    let noGoAdjacency = {}
    let noGoEdges = new Set()

    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge, i) => {
      if (i === 0) newObjects.edges = []
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]
      let reverse = true
      if (edge.pointerAtEnding) {
        reverse = false
      }
      if (edge.pointerAtBeginning) {
        reverse = false
        pointA = edge.pointIds[1]
        pointB = edge.pointIds[0]
      }

      switch (edge.stroke) {
        case 'purple':
          newObjects.edges.push({ avoid: true, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'blue':
          newObjects.edges.push({ avoid: false, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'red':
          if (!noGoAdjacency[pointA]) noGoAdjacency[pointA] = []
          if (!noGoAdjacency[pointB]) noGoAdjacency[pointB] = []
          noGoAdjacency[pointA].push(pointB)
          noGoAdjacency[pointB].push(pointA)
          break

        default:
          break
      }
    })

    let noGoPolygons = []
    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge) => {
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]

      if (edge.stroke === 'red') {
        if (!noGoEdges.has(edgeKey(pointA, pointB))) {
          const polygon = tracePolygon(pointA, noGoEdges, noGoAdjacency)
          noGoPolygons.push(polygon)
        }
      }
    })

    let finalNoGo = noGoPolygons.map((polygon) => {
      let corners = polygon.map((corner) => {
        let correctCorner = noGoPoints.find((point) => corner === point.name || point.name.includes(corner))
        if (!correctCorner) return null
        return { counter: correctCorner.counter, point: correctCorner.point }
      }).filter(Boolean)

      return { polygon: corners }
    })

    if (finalNoGo.length !== 0) newObjects.no_go = finalNoGo

    context.konvaZones.length !== 0 && context.konvaZones.forEach((zone, i) => {
      if (i === 0) newObjects.areas = []
      let beep

      switch (zone.stroke) {
        case 'orange':
          beep = false
          break

        case 'hotpink':
          beep = true
          break

        default:
          break
      }

      newObjects.areas.push({
        velocity: zone.velocity,
        beep: beep,
        name: zone.name,
        polygon: [
          { counter: 'pz1-' + (i + 1), point: toWorldPoint(zone.x, zone.y) },
          { counter: 'pz2-' + (i + 1), point: toWorldPoint(zone.x + zone.width * zone.scaleX, zone.y) },
          { counter: 'pz3-' + (i + 1), point: toWorldPoint(zone.x + zone.width * zone.scaleX, zone.y + zone.height * zone.scaleY) },
          { counter: 'pz4-' + (i + 1), point: toWorldPoint(zone.x, zone.y + zone.height * zone.scaleY) }
        ]
      })
    })

    return newObjects
  }

  const formatPointValue = (point) => {
    if (!point?.point) return '-'
    return `${roundCoord(point.point.x)}, ${roundCoord(point.point.y)}`
  }

  const formatEdgeLabel = (edge) => `${edge.from} → ${edge.to}`

  const cloneObjects = (objects = {}) => JSON.parse(JSON.stringify(objects || {}))

  const hasMapData = (objects) => {
    if (!objects || typeof objects !== 'object') return false

    return ['points', 'edges', 'areas', 'no_go'].some((key) => Array.isArray(objects[key]) && objects[key].length > 0)
  }

  const normalizeProfiles = (mapItem = {}) => {
    const profiles = []

    if (Array.isArray(mapItem?.profiles)) {
      mapItem.profiles.forEach((entry) => {
        if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return

        const [profileName] = Object.keys(entry)
        if (!profileName) return

        profiles.push({ name: profileName, objects: cloneObjects(entry[profileName]) })
      })
    }

    if (profiles.length === 0 && hasMapData(mapItem?.profile)) {
      profiles.push({ name: 'Default', objects: cloneObjects(mapItem.profile) })
    }

    return profiles
  }

  const serializeProfiles = (profiles = []) => profiles.map((profile) => ({ [profile.name]: cloneObjects(profile.objects) }))

  const getProfileNames = (mapItem) => normalizeProfiles(mapItem).map((profile) => profile.name)

  const getProfileObjects = (mapItem, profileName) => {
    const profile = normalizeProfiles(mapItem).find((item) => item.name === profileName)
    return profile ? cloneObjects(profile.objects) : {}
  }

  const getCurrentMapItem = () => context.maps.find((map) => map.name === selectedMapName && map.robotId === currentRobotId)
    || context.maps[context.mapIndex]
    || null

  const resolveActiveProfileName = (mapItem, preferredName) => {
    const profileNames = getProfileNames(mapItem)

    if (preferredName && profileNames.includes(preferredName)) return preferredName
    if (profileNames.includes('Default')) return 'Default'
    return profileNames[0] || 'Default'
  }

  const buildProfilesForSave = (mapItem, profileName, objects) => {
    let profiles = normalizeProfiles(mapItem)

    if (profiles.length === 0) {
      profiles = [{ name: 'Default', objects: cloneObjects(mapItem?.objects || {}) }]
    }

    const targetProfileName = profileName || (profiles.find((profile) => profile.name === 'Default') ? 'Default' : profiles[0]?.name)
    const profileIndex = profiles.findIndex((profile) => profile.name === targetProfileName)
    const nextProfile = { name: targetProfileName, objects: cloneObjects(objects) }

    if (profileIndex >= 0) profiles[profileIndex] = nextProfile
    else profiles.push(nextProfile)

    return serializeProfiles(profiles)
  }

  const applyObjectsToKonva = (mapItem, objects) => {
    if (!hasMapData(objects)) {
      context.actions.setMapObjects({})
      context.actions.setKonvaPoints([])
      context.actions.setKonvaEdges([])
      context.actions.setKonvaZones([])
      return
    }

    const resolution = Number(mapItem?.resolution) > 0 ? Number(mapItem.resolution) : 1
    const originX = Number(mapItem?.origin?.x) || 0
    const originY = Number(mapItem?.origin?.y) || 0
    const mapHeight = Number(context.mapDimensions?.height) || 0

    const toCanvasPoint = (point) => ({
      x: (Number(point?.x) - originX) / resolution,
      y: -(Number(point?.y) - originY) / resolution + mapHeight
    })

    let allPoints = []
    let allEdges = []
    let allZones = []

    if (Array.isArray(objects.points)) {
      allPoints = objects.points
        .filter((point) => point?.point)
        .map((point) => {
          const canvasPoint = toCanvasPoint(point.point)
          return {
            draggable: 'true',
            fill: 'blue',
            name: point.name?.[0],
            radius: 5,
            x: canvasPoint.x,
            y: canvasPoint.y
          }
        })
    }

    if (Array.isArray(objects.edges)) {
      allEdges = objects.edges.reduce((acc, edge) => {
        const startPoint = allPoints.find((point) => point.name === edge.from)
        const endPoint = allPoints.find((point) => point.name === edge.to)

        if (!startPoint || !endPoint) return acc

        const color = edge.avoid ? 'purple' : 'blue'
        const pointer = !edge.reversable

        acc.push({
          points: [startPoint.x, startPoint.y, endPoint.x, endPoint.y],
          stroke: color,
          hitStrokeWidth: 15,
          fill: color,
          opacity: 0.5,
          name: startPoint.name + ' a ' + endPoint.name,
          pointerAtEnding: pointer,
          pointIds: [startPoint.name, endPoint.name]
        })

        return acc
      }, [])
    }

    if (Array.isArray(objects.no_go)) {
      let noGoEdges = []

      objects.no_go.forEach((zone) => {
        if (!Array.isArray(zone?.polygon) || zone.polygon.length === 0) return

        const noGoPoints = zone.polygon
          .filter((item) => item?.point)
          .map((item) => {
            const canvasPoint = toCanvasPoint(item.point)
            return {
              draggable: 'true',
              fill: 'red',
              name: item.counter,
              radius: 4,
              x: canvasPoint.x,
              y: canvasPoint.y
            }
          })

        for (let i = 0; i < noGoPoints.length - 1; i++) {
          noGoEdges.push({
            points: [noGoPoints[i].x, noGoPoints[i].y, noGoPoints[i + 1].x, noGoPoints[i + 1].y],
            stroke: 'red',
            hitStrokeWidth: 15,
            fill: 'red',
            opacity: 0.5,
            name: noGoPoints[i].name + ' a ' + noGoPoints[i + 1].name,
            pointerAtEnding: false,
            pointIds: [noGoPoints[i].name, noGoPoints[i + 1].name]
          })
        }

        if (noGoPoints.length > 2) {
          noGoEdges.push({
            points: [noGoPoints[noGoPoints.length - 1].x, noGoPoints[noGoPoints.length - 1].y, noGoPoints[0].x, noGoPoints[0].y],
            stroke: 'red',
            hitStrokeWidth: 15,
            fill: 'red',
            opacity: 0.5,
            name: noGoPoints[noGoPoints.length - 1].name + ' a ' + noGoPoints[0].name,
            pointerAtEnding: false,
            pointIds: [noGoPoints[noGoPoints.length - 1].name, noGoPoints[0].name]
          })
        }

        allPoints = allPoints.concat(noGoPoints)
      })

      allEdges = allEdges.concat(noGoEdges)
    }

    if (Array.isArray(objects.areas)) {
      allZones = objects.areas
        .filter((zone) => Array.isArray(zone?.polygon) && zone.polygon.length >= 4)
        .map((zone) => {
          const first = toCanvasPoint(zone.polygon[0].point)
          const second = toCanvasPoint(zone.polygon[1].point)
          const fourth = toCanvasPoint(zone.polygon[3].point)
          const beep = Boolean(zone.beep)

          return {
            name: zone.name,
            fill: beep ? '#FF7FE8' : '#FFB47F',
            stroke: beep ? 'hotpink' : 'orange',
            strokeWidth: 1,
            opacity: 0.6,
            x: first.x,
            y: first.y,
            draggable: 'true',
            height: -(first.y - fourth.y),
            width: second.x - first.x,
            rotation: Math.atan2(zone.polygon[1].point.y - zone.polygon[0].point.y, zone.polygon[1].point.x - zone.polygon[0].point.x) * (180 / Math.PI),
            scaleX: 1,
            scaleY: 1,
            velocity: zone.velocity
          }
        })
    }

    context.actions.setMapObjects(objects)
    context.actions.setKonvaPoints(allPoints)
    context.actions.setKonvaEdges(allEdges)
    context.actions.setKonvaZones(allZones)
  }

  useEffect(() => {
    const currentMap = context.maps.find((map) => map.name === selectedMapName && map.robotId === currentRobotId)
      || context.maps[context.mapIndex]
      || null

    if (!currentMap) {
      setSelectedProfileName('')
      return
    }

    const profileNames = []

    if (Array.isArray(currentMap?.profiles)) {
      currentMap.profiles.forEach((entry) => {
        if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return

        const [profileName] = Object.keys(entry)
        if (profileName) profileNames.push(profileName)
      })
    }

    if (profileNames.length === 0 && hasMapData(currentMap?.profile)) {
      profileNames.push('Default')
    }

    if (profileNames.length === 0) {
      setSelectedProfileName('')
      return
    }

    let matchingProfileName = null
    if (Array.isArray(currentMap?.profiles) && currentMap.profiles.length > 0) {
      const localStableSerialize = (value) => {
        if (Array.isArray(value)) {
          return `[${value.map((entry) => localStableSerialize(entry)).join(',')}]`
        }

        if (value && typeof value === 'object') {
          const keys = Object.keys(value).sort()
          return `{${keys.map((key) => `${JSON.stringify(key)}:${localStableSerialize(value[key])}`).join(',')}}`
        }

        return JSON.stringify(value)
      }

      const profileEntries = currentMap.profiles.reduce((acc, entry) => {
        if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return acc

        const [profileName] = Object.keys(entry)
        if (!profileName) return acc

        acc.push({ name: profileName, objects: entry[profileName] || {} })
        return acc
      }, [])

      const objectSignature = localStableSerialize(currentMap.objects || {})
      const matchedProfile = profileEntries.find((profile) => localStableSerialize(profile.objects || {}) === objectSignature)
      matchingProfileName = matchedProfile?.name || null
    }

    setSelectedProfileName((currentName) => {
      if (matchingProfileName && profileNames.includes(matchingProfileName)) return matchingProfileName
      if (currentName && profileNames.includes(currentName)) return currentName
      if (profileNames.includes('Default')) return 'Default'
      return profileNames[0]
    })
  }, [selectedMapName, currentRobotId, context.mapIndex, context.maps])

  const openProfileModal = () => {
    const currentMap = getCurrentMapItem()

    if (!currentMap) {
      context.actions.setMessage({ message: 'Selecione um mapa primeiro', type: 'error' })
      return false
    }

    setModalData({ profileName: '' })
    setModal('profile')
  }

  const saveProfile = async () => {
    const maps = [...context.maps]
    const mapIndex = maps.findIndex(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo?._id)

    if (mapIndex < 0) {
      context.actions.setMessage({ message: 'Mapa selecionado nao encontrado', type: 'error' })
      setModal(false)
      return false
    }

    const selectedMap = maps[mapIndex]
    const profileName = modalData?.profileName?.trim()

    if (!profileName) {
      context.actions.setMessage({ message: 'Informe o nome do profile', type: 'error' })
      return false
    }

    if (profileName.toLowerCase() === 'default') {
      context.actions.setMessage({ message: 'Default ja e reservado para o profile inicial', type: 'error' })
      return false
    }

    if (~profileName.indexOf('.') || ~profileName.indexOf('/') || ~profileName.indexOf('\\') || ~profileName.indexOf(';') || ~profileName.indexOf(':')) {
      context.actions.setMessage({ message: 'Nome de profile invalido', type: 'error' })
      return false
    }

    validateZone()
    const currentObjects = buildObjectsForExport(selectedMap)
    let profiles = normalizeProfiles(selectedMap)

    if (profiles.some((profile) => profile.name.toLowerCase() === profileName.toLowerCase())) {
      context.actions.setMessage({ message: 'Ja existe um profile com esse nome', type: 'error' })
      return false
    }

    if (!profiles.find((profile) => profile.name === 'Default')) {
      profiles = [{ name: 'Default', objects: cloneObjects(currentObjects) }, ...profiles]
    }

    profiles.push({ name: profileName, objects: {} })

    let payload = {
      ...selectedMap,
      objects: selectedMap.objects || {},
      profiles: serializeProfiles(profiles),
      syncFMS: true
    }

    delete payload.active
    delete payload.profile

    try {
      let updateResult = true

      if (selectedMap?._id) {
        updateResult = await api.updateMap(payload)
      }

      if (!updateResult) {
        context.actions.setMessage({ message: 'Falha ao criar profile no FMS', type: 'error' })
        return false
      }

      maps[mapIndex] = payload
      context.actions.setMaps(maps)
      context.actions.setChanges([])
      context.actions.setUndone([])
      setSelectedProfileName(profileName)
      applyObjectsToKonva(payload, {})

      context.actions.setMessage({
        message: selectedMap?._id
          ? 'Profile criado e sincronizado no FMS'
          : 'Profile criado localmente. Sincronize o mapa para enviar ao FMS',
        type: 'success'
      })
    } catch (error) {
      console.log('Erro ao criar profile no FMS', error)
      context.actions.setMessage({ message: 'Erro ao criar profile no FMS', type: 'error' })
      return false
    } finally {
      setModal(false)
      setModalData(null)
    }
  }

  const selectProfile = (event) => {
    const profileName = event.target.value
    const currentMap = getCurrentMapItem()

    if (!currentMap) {
      context.actions.setMessage({ message: 'Selecione um mapa primeiro', type: 'error' })
      return false
    }

    setSelectedProfileName(profileName)
    context.actions.setChanges([])
    context.actions.setUndone([])
    context.actions.setSelected({ mapObject: null, connect: null })
    applyObjectsToKonva(currentMap, getProfileObjects(currentMap, profileName))
  }

  const openSyncModal = () => {
    const currentMap = context.maps.find(m => m.name === context.selected.map?.name)
    if (!currentMap) {
      context.actions.setMessage({ message: "Selecione um mapa primeiro", type: "error" })
      return false
    }

    validateZone()
    const newObjects = buildObjectsForExport(currentMap)
    const preview = buildSyncPreview(context.mapObjects, newObjects)

    setSyncPreparedObjects(newObjects)
    setSyncPreview(preview)
    setModal("sync")
  }

  const confirmSync = () => {
    setModal(false)
    exportMaps(syncPreparedObjects)
    setSyncPreparedObjects(null)
    setSyncPreview(null)
  }

  const exportMaps = async (preparedObjects) => {
    let maps = [...context.maps]
    const currentMap = context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo?._id)
      || context.maps.find(m => m.name === context.selected.map?.name)
    const activeProfileName = resolveActiveProfileName(currentMap, selectedProfileName)
    validateZone()
    console.log(context.konvaPoints, context.konvaEdges, context.mapObjects, currentMap)

    const newObjects = preparedObjects || buildObjectsForExport(currentMap)

    console.log(newObjects, context.mapObjects, context.mapIndex)

    var index = maps.findIndex((e) => e.name === context.selected?.map?.name && e.robotId === context.selected?.map?.robotId)

    if (index < 0) {
      index = maps.findIndex((e) => e.name === context.selected?.map?.name && e.robotId === context.robotInfo?._id)
    }

    if (index < 0) {
      index = maps.findIndex((e) => e.name === context.selected?.map?.name)
    }

    console.log(index)

    const newMap = {
      ...maps[index],
      objects: newObjects,
      profiles: buildProfilesForSave(maps[index], activeProfileName, newObjects)
    }
    delete newMap.profile
    maps[index] = newMap
    context.actions.setMapObjects(newObjects)
    console.log(context.maps, maps)
    context.actions.setMaps(maps)

    if (context.diagnosticSwitch)
      c("DBug: exportMaps - map selected ", context.selected)

    if (!context.robotInfo) {
      context.actions.setMessage({ message: "Robot not registered on FMS. Please register it with the official name.", type: "error" })
      return false
    }

    if (context.settings.fmsConnection) {

      console.log(maps)

      getMapOccurrence(maps, context.selected.map.name)

      var mapId, respMap

      console.log(context.selected.map)



      if (index || index === 0) {
        if (!maps[index]?._id) {

          console.log(context.mapFeedFull)
          //NEW MAP

          if (context.diagnosticSwitch)
            c("ExportMaps - New Map: ", "name: ", context.selected.map.name, " owner: ", context.robotInfo.owner, "robotId:", context.robotInfo._id, "areaId: ", context.robotInfo.areaId, "origin: ", context.mapFeedFull.origin.position, "objects: ", newObjects, "resolution: ", context.mapFeedFull.resolution)

          try {
            // Capturar imagem do mapa antes de enviar
            let mapImageBase64 = null
            let sentWithoutImage = false
            try {
              const canvasElement = canvasRef.current?.querySelector('canvas')
              if (canvasElement) {
                context.actions.setMessage({ message: "Capturando imagem do mapa...", type: "info" })
                mapImageBase64 = api.canvasToBase64(canvasElement, {
                  maxWidth: 1600,
                  maxHeight: 900,
                  maxSizeKB: 350,
                  quality: 0.8,
                  mimeType: 'image/jpeg'
                })
                if (context.diagnosticSwitch)
                  c("ExportMaps - Canvas captured, size: ", api.base64SizeKB(mapImageBase64).toFixed(2), "KB")
              }
            } catch (imageError) {
              console.warn("Erro ao capturar imagem, enviando sem imagem:", imageError)
              context.actions.setMessage({ message: "Falha ao capturar imagem do mapa (canvas/cors). Sincronizando sem imagem.", type: "warning" })
              sentWithoutImage = true
            }

            const mapPayload = {
              name: context.selected.map.name,
              owner: context.robotInfo.owner,
              robotId: context.robotInfo._id,
              areaId: context.robotInfo.areaId,
              origin: context.mapFeedFull.origin.position,
              resolution: context.mapFeedFull.resolution,
              objects: newObjects,
              profiles: newMap.profiles,
              syncFMS: true,
              imageData: mapImageBase64
            }

            // Enviar dados do mapa com fallback sem imagem em payload grande
            try {
              respMap = await api.saveMap(mapPayload)
            } catch (saveError) {
              if (saveError?.response?.status === 413 && mapPayload.imageData) {
                const payloadWithoutImage = { ...mapPayload }
                delete payloadWithoutImage.imageData
                context.actions.setMessage({ message: "Imagem muito grande para o FMS. Enviando mapa sem imagem...", type: "info" })
                respMap = await api.saveMap(payloadWithoutImage)
                sentWithoutImage = true
              } else {
                throw saveError
              }
            }

            c("** RespMAP ", respMap)
            if (!respMap || respMap.status === 401) {
              context.actions.setMessage({ message: "Error to export, try again or reconnect to login", type: "error" })
              return false
            }

            mapId = respMap.data._id

            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "New Index: ", mapId)

            if (respMap) {
              context.actions.setMessage({
                message: sentWithoutImage ? "Mapa sincronizado sem imagem" : "Mapa e imagem sincronizados com sucesso",
                type: sentWithoutImage ? "warning" : "success"
              })
            }

          } catch (error) {
            context.actions.setMessage({ message: "Error to export", type: "error" })
            console.log("Error", error)
          }

          if (mapId) {
            //let newMaps = maps.splice(index, 1, Object.assign({}, maps[index], { _id: mapId }));
            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "Add ID: ", mapId)
            let newMaps = [...maps]

            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "Map array: ", newMaps)

            newMaps[index]._id = mapId

            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "Map with ID: ", newMaps, " -  Map Update ID: ", newMaps[index]._id)

            context.actions.setMaps(newMaps)
          } else {
            context.actions.setMessage({ message: "No map ID found on FMS", type: "error" })
          }


        } else {
          console.log('updating')
          //UPDATE MAP
          if (context.diagnosticSwitch)
            c("ExportMaps - Update map: name before filtered: ", maps[index])


          // Capturar imagem do mapa antes de atualizar
          let mapImageBase64 = null
          let sentWithoutImage = false
          try {
            const canvasElement = canvasRef.current?.querySelector('canvas')
            if (canvasElement) {
              context.actions.setMessage({ message: "Capturando imagem atualizada do mapa...", type: "info" })
              mapImageBase64 = api.canvasToBase64(canvasElement, {
                maxWidth: 1600,
                maxHeight: 900,
                maxSizeKB: 350,
                quality: 0.8,
                mimeType: 'image/jpeg'
              })
              if (context.diagnosticSwitch)
                c("ExportMaps - Updated canvas captured, size: ", api.base64SizeKB(mapImageBase64).toFixed(2), "KB")
            }
          } catch (imageError) {
            console.warn("Erro ao capturar imagem atualizada:", imageError)
            context.actions.setMessage({ message: "Falha ao capturar imagem do mapa (canvas/cors). Atualizando sem imagem.", type: "warning" })
            sentWithoutImage = true
          }

          let filteredMap = maps[index]
          delete filteredMap.active
          filteredMap.syncFMS = true
          if (mapImageBase64) {
            filteredMap.imageData = mapImageBase64 // Adiciona imagem do canvas
          }
          // console.log("updating FMS with map", filteredMap)

          if (context.diagnosticSwitch)
            c("ExportMaps - Update map: map Object to update : ", filteredMap)

          let updateResult
          try {
            updateResult = await api.updateMap(filteredMap)
          } catch (updateError) {
            const isPayloadError = updateError?.response?.status === 413
            if (isPayloadError && filteredMap.imageData) {
              const payloadWithoutImage = { ...filteredMap }
              delete payloadWithoutImage.imageData
              context.actions.setMessage({ message: "Imagem muito grande para o FMS. Atualizando mapa sem imagem...", type: "info" })
              updateResult = await api.updateMap(payloadWithoutImage)
              sentWithoutImage = true
            } else {
              console.log("Erro ao atualizar mapa no FMS", updateError)
              context.actions.setMessage({ message: "Erro ao atualizar mapa no FMS", type: "error" })
              return false
            }
          }

          if (updateResult) {
            context.actions.setMessage({
              message: sentWithoutImage ? "Mapa atualizado sem imagem" : "Mapa e imagem atualizados no FMS",
              type: sentWithoutImage ? "warning" : "success"
            })
          }
          else context.actions.setMessage({ message: "map or points not updated on FMS", type: "error" })
          if (context.diagnosticSwitch)
            c("ExportMaps - Update map: Map update on FMS result: ", updateResult)
        }
      } else {
        context.actions.setMessage({ message: "Map not saved, please save gu", type: "error" })
        return false
      }

    } else {

      context.actions.setMessage({ message: "Error: fms Connection is not available, please verify in Settings", type: "error" })
      return false

    }

  }

  // improve map ----------------------------------------------------

  const saveMapImprove = async () => {

    setModal(null)

    if (!context.selected.map) {
      setModalData(false)
      if (context.selectedRobot.ROS === 'ROS2') {
        cancelActions({ stopmapping: true }, context.selectedRobot.ROS)
      } else {
        cancelActions({ stopMapping: true }, context.selectedRobot.ROS)
      }
      context.actions.setSavingStatus(true)
      setIsMapping(!isMapping)
      setTypeMap(false)
      context.actions.setMessage({ message: "Please select available map", type: "error" })
      return false
    }

    //context.actions.setMaps([...maps, { name:  context.selected.map?.name, robot: context.selectedRobot.name, active: true, _id: mapId }])
    context.actions.setMappingCurrent({ name: context.selected.map?.name, robot: context.selectedRobot.name, mapping: isMapping, robotId: context.robotInfo._id })
    sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: context.selected.map?.name }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
    //context.actions.setSelected({ map: { name: context.selected.map?.name } })

    // subscribe to map
    if (canvas) {
      // console.log("subscribing to map")
      window.mapSubscriber = ROS.subscribeMap(callback, canvas, context, false)
    }
  }

  // select map -----------------------------------------------------

  const selectMap = async (event) => {
    const index = context.maps.findIndex(m => m.name === event.target.value)
    const map = context.maps[index]
    console.log(index, map)
    context.actions.setMapIndex(index)
    context.actions.setSelected({ map: { name: event.target.value, robotId: context.robotInfo._id } })
    context.actions.setHelpers({ ...context.helpers, newItem: true })
    setIsMapping((context.mappingCurrent && context.mappingCurrent.name === event.target.value) ? context.mappingCurrent?.mapping : false)
    context.actions.setMapObjects(map.objects ? map.objects : {})
    context.actions.setChanges([])
    context.actions.setUndone([])

    let maps = context.maps.map(m => m.robotId === context.robotInfo._id && m.name === event.target.value ?
      ({ ...m, active: true })
      : m.robotId === context.robotInfo._id ?
        ({ ...m, active: false })
        :
        (m))

    console.log(maps)
    //context.actions.setMaps(maps)

    if (context.endOfMission) sendTaskToRobot({ actions: [{ id: "select-map", name: "select-map", value: event.target.value }], id: "select-map", name: "select-map" }, context.selectedRobot.ROS)

    // console.log("fms getting map info", context.settings.fmsConnection, map._id)
    // fms sync
    if (context.settings.fmsConnection) {//&& map._id) {
      // update default map on area item on FMS (site and area for the robot must be defined)
      // console.log("updating area map", context.robotInfo.areaId, map._id)

      //#api.updateAreaMap(context.robotInfo.areaId, map._id)

      // retrieve map nav info from fms
      // console.log("selected map target 1", event.target.value)
      //const updatedMap = await api.getMap(event.target.value)
      //const mapsByFMS = await api.fetchMaps()
      // console.log("updated map", updatedMap)

      //var mapsApi = mapsByFMS.data
      //var mapLocal = context.maps

      /****************/
      //const sameMap = (mapsApi, mapLocal) => mapsApi.name === mapLocal.name && mapsApi.robot === mapLocal.robot;

      //var mapsApiDiff = new CompareArray().compareArrays(mapsApi, mapLocal, sameMap);
      //var mapLocalDiff = new CompareArray().compareArrays(mapLocal, mapsApi, sameMap);

      //var result = [...mapsApiDiff, ...mapLocalDiff];

      //console.log("--", result, index)

      /****************/

      //Rollback this value
      /*
            if (Array.isArray(updatedMap.data) && updatedMap.data[0].objects) {
              const newMaps = [...context.maps]
              newMaps[index].objects = updatedMap.data[0].objects
              console.log("retrieved map nav info from fms", updatedMap.data[0].objects)
              
              context.actions.setMaps(newMaps)
            }
            */
    }
  }

  // reset map --------------------------------------------------------------

  const resetMap = () => {
    let newMap = { ...context.maps[context.mapIndex] }
    newMap.objects = {}
    let newMaps = [...context.maps]
    newMaps[context.mapIndex] = newMap
    context.actions.setMapObjects({})
    context.actions.setKonvaPoints([])
    context.actions.setKonvaEdges([])
    context.actions.setKonvaZones([])
    context.actions.setMaps(newMaps)
    setModal(false)

    console.log(context.maps, newMaps)
    console.log(context.selected, newMap)

    // update map on FMS
    /* if (context.settings.fmsConnection && newMap._id) {
       api.updateMap(newMap)
     }*/
  }

  // update modal data ------------------------------------------------

  const updateModalData = (item, value) => {
    const data = { ...modalData, [item]: value }
    setModalData(data)

    // update point label and zone max velocity and beep
    let newObjects = { ...context.mapObjects }

    if (!context.selected.mapObject) return false

    switch (context.selected.mapObject.type) {
      case 'points':
        //  console.log("updating point", context.selected.connect)
        let currentPointName = newObjects.points[context.selected.mapObject.idx].name

        // update existing edges related to the point
        context.mapObjects.edges && context.mapObjects.edges.forEach((e, i) => {
          if (e.from === currentPointName) {
            // console.log("updating edge point from", i, currentPointName, data.name)
            newObjects.edges[i].from = data.name
          }
          if (e.to === currentPointName) {
            //  console.log("updating edge point to", i, currentPointName, data.name)
            newObjects.edges[i].to = data.name
          }
        })

        // update point name
        newObjects.points[context.selected.mapObject.idx].name = data.name
        break
      case 'edges':
        if (context.selected.connect && newObjects.edges) { // edge update
          //  console.log("updating edge", data)
          newObjects.edges[context.selected.mapObject.idx].reversable = data.reversable
          newObjects.edges[context.selected.mapObject.idx].avoid = data.avoid
          break
        }
        break
      case 'areas':
        // console.log("updating zone", context.selected.mapObject.idx, data)
        newObjects.areas[context.selected.mapObject.idx].velocity = parseFloat(data.velocity)
        newObjects.areas[context.selected.mapObject.idx].beep = data.beep
        break
      default:
    }

    context.actions.setMapObjects(newObjects)
  }

  // closeModal ------------------------------------------------------------

  const closeModal = () => {
    setModal(false)
    setModalData(false)
    setIsMapping(false)
    setTypeMap(false)

    if (!modalData?.name && (modal === 'points' || modal === 'areas')) undo()

    context.actions.setSelected({ mapObject: null })
    context.actions.setHelpers({ ...context.helpers, editing: false })
  }

  // change hand side -----------------------------------------------------

  const handSelected = () => {
    setHand(!hand)
  }

  // change hand on orientation ------------------------------------------
  /*
    useEffect(() => {
      (orientation) ? setHand(true) : setHand(false)
    }, [orientation])*/

  // toggle mapping ------------------------------------------------------

  const toggleMapping = (typeModal) => {
    if (isMapping) {
      if (context.selectedRobot.ROS === 'ROS2') {
        cancelActions({ stopmapping: true }, context.selectedRobot.ROS)
      } else {
        cancelActions({ stopMapping: true }, context.selectedRobot.ROS)
      }
      context.actions.setSavingStatus(true)
      console.log(context.mappingCurrent, context.selected)
      if (context.settings.fmsConnection) {
        if (context.mappingCurrent) context.actions.setSelected({ map: { name: context.mappingCurrent.name, robotId: context.robotInfo._id } })
      } else fetchMapInformation()
      context.actions.setMappingCurrent(null)
      setModalData(null)
      if (context.settings.fmsConnection) exportMaps()
      setHand(false)
      setTypeMap(false)
      // console.log("preparing to shut down map subscriber")
      if (window.mapSubscriber) {
        // console.log("shutting down map subscriber")
        window.mapSubscriber.shutdown()
      }
    } else {
      context.actions.setKonvaPoints([])
      context.actions.setKonvaEdges([])
      context.actions.setKonvaZones([])
      context.actions.setChanges([])
      context.actions.setUndone([])
      openModal(typeModal)
      setTypeMap(typeModal)
    }

    setIsMapping(!isMapping)
  }

  // delete map ----------------------------------------------------------

  const deleteMap = async () => {

    const indx = context.maps.findIndex(v => v.name === context.selected.map?.name && v.robotId === context.robotInfo._id)
    if (indx < 0) {
      setModal(false)
      return false
    }

    console.log("ExportMaps - Update map: name before filtered : ", context.maps[indx])

    let filteredMap = context.maps[indx]
    console.log(filteredMap)
    delete filteredMap.active
    filteredMap.deleted = true
    filteredMap.syncFMS = false
    console.log("updating FMS with map", filteredMap)

    console.log("ExportMaps - Update map: map Object to update : ", filteredMap)

    let updateResult = await api.updateMap(filteredMap)
    if (updateResult) context.actions.setMessage({ message: "Resultado do mapa atualizado no FMS", type: "success" })
    else context.actions.setMessage({ message: "Mapa ou pontos não atualizados no FMS", type: "error" })
    if (context.diagnosticSwitch)
      c("ExportMaps - Update map: Map update on FMS result: ", updateResult)

    const maps = [...context.maps]
    maps.splice(indx, 1)
    context.actions.setMaps(maps)

    //context.actions.setSelected({ map: context.maps[0]?.name ? context.maps[0].name  :  null})
    context.actions.setSelected({ map: { name: "Select map" } })
    context.actions.setKonvaPoints([])
    context.actions.setKonvaEdges([])
    context.actions.setKonvaZones([])
    context.actions.setChanges([])
    context.actions.setUndone([])
    setModal(false)
  }

  // Processing image callback --------------------------------------------

  /*const callback = (msg, canvas, context, firstRun) => {
    OccupancyGridVisualizer.drawMap(msg, canvas)
    let header = msg.header
    canvas.needsUpdate = true
    let width = msg.info.width * msg.info.resolution
    let height = msg.info.height * msg.info.resolution
    let scale = [width, height, 1]
    let position = [(msg.info.origin.position.x + width / 2), (msg.info.origin.position.y + height / 2), 0]
    console.log(canvas)
    context.actions.setMapFeed({ canvas: canvas, header: header, scale: scale, position: position })
    context.actions.setMapOrientation({ x: parseFloat(msg.info.origin.position.x + width / 2).toFixed(4), y: parseFloat(msg.info.origin.position.y + width / 2).toFixed(4) })

    // update map resolution and origin on first run for the selected map
    if (firstRun && msg.info.resolution && msg.info.origin) {
      const currentMap = context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo._id)
      // console.log("updating map resolution", firstRun)
      if (!currentMap) return false
      currentMap.resolution = msg.info.resolution
      currentMap.origin = msg.info.origin
      let newMaps = [...context.maps]
      newMaps[context.mapIndex] = currentMap
      context.actions.setMaps(newMaps)

      // update FMS
      /* if (context.settings.fmsConnection) {
          api.updateMap(currentMap)
        }
    }
  }*/

  const callback = (msg, canvas, context, firstRun) => {

  }

  // Subscribe to map feed once on load ----------------------------------------------------------

  useEffect(() => {
    // if (canvas) console.log("running map subscriber once")
    //if (canvas) ROS.subscribeMapOnce(callback, canvas, context, true)
    //  if (context.selected.map === null || context.selected.map === undefined) context.actions.setSelected({map: { name: "Select map"}})
  }, [canvas, context.selected.map])

  // select last map used for this robot ----------------------------------------------------------

  const fetchMaps = async () => {
    if (context.settings.fmsConnection) {
      let res

      res = await api.fetchMaps({ syncFMS: true })

      console.log('MAPS:', res)

      if (res?.data) context.actions.setMaps(res?.data)
    }
  }

  const fetchMapInformation = async () => {
    console.log('fetching map name from txt...')

    fetch('http://' + context.selectedRobot.ip + '/map.txt?nocache=' + Date.now())
      .then(response => {
        response.text()
          .then(text => {
            console.log('map name is ', text)
            let noSpacing = text.replace(/\n/g, '')
            context.actions.setSelected({ ...context.selected, map: { name: noSpacing } })
          })
      })
      .catch(error => {
        console.error(error)
      })

    console.log('fetching nav info from xml...')
    let points, edges, areas, no_go

    fetch('http://' + context.selectedRobot.ip + '/navInfo.xml?nocache=' + Date.now())
      .then(response => {
        response.text()
          .then(info => {
            const xmlDoc = new DOMParser().parseFromString(info, 'text/xml')

            const navPoints = [...xmlDoc.querySelectorAll('navPoints > *')].map((point) => ({
              counter: 'pn-' + point.querySelector('ID')?.textContent.trim(),
              name: [point.querySelector('ID_FMS')?.textContent.trim()],
              point: { x: parseFloat(point.querySelector('X')?.textContent.trim()), y: parseFloat(point.querySelector('Y')?.textContent.trim()) }
            }))

            console.log('points are ', navPoints)

            let counter = 0

            const navPaths = [...xmlDoc.querySelectorAll('navEdges > *')].map((path) => {
              const navEdges = [...path.getElementsByTagName(`*`)].filter(node => node.nodeName.startsWith('navEdge')).map((edge, index) => {
                const id1 = edge.querySelector('ID1')?.textContent?.trim()
                const id2 = edge.querySelector('ID2')?.textContent?.trim()
                const avoidText = edge.querySelector('Avoid')?.textContent?.trim()
                const reverseText = edge.querySelector('Reversable')?.textContent?.trim()

                console.log(`ID1: ${id1}, ID2: ${id2}, Avoid: ${avoidText}, Reversable: ${reverseText}`)

                if (!id1 || !id2) {
                  return null
                }

                if (id1 !== id2) {
                  counter++
                  return {
                    avoid: avoidText === "0" ? false : true,
                    counter: 'ln-' + counter,
                    from: navPoints[Number(id1)]?.name?.[0] || "Unknown",
                    reversable: reverseText === "0" ? false : true,
                    to: navPoints[Number(id2)]?.name?.[0] || "Unknown"
                  };
                }

                return null;
              })

              let deleteNulls = navEdges.filter(function (el) {
                return el != null;
              });

              return deleteNulls
            })

            let arrayOfArrays = []
            let actualEdges = []

            navPaths.forEach((path) => {
              if (path.length !== 0) arrayOfArrays.push(path)
            })

            arrayOfArrays.forEach((edge) => {
              edge.forEach((e) => {
                actualEdges.push(e)
              })
            })

            let seen = new Object()

            actualEdges.forEach(edge => {
              let key = `${edge.from}-${edge.to}`
              let reverseKey = `${edge.to}-${edge.from}`

              if (seen[reverseKey]) {
                seen[reverseKey].reversable = true
                edge.reversable = true
              } else {
                edge.reversable = false
                seen[key] = edge
              }
            })

            let noDupes = Object.values(seen);
            points = navPoints
            console.log('edges are ', noDupes)
            edges = noDupes

            console.log('fetching zones from xml...')

            fetch('http://' + context.selectedRobot.ip + '/slowZones.xml?nocache=' + Date.now())
              .then(response => {
                response.text()
                  .then(info => {
                    const xmlDoc = new DOMParser().parseFromString(info, 'text/xml')

                    const navZones = [...xmlDoc.querySelectorAll('slowZone > *')].map((zone, i) => {
                      const zonePoints = [...xmlDoc.querySelectorAll(`Polygon${i} > *`)].map((point, j) => {
                        if (j > 3) return null
                        return {
                          counter: 'pz' + i + '-' + j,
                          point: { x: parseFloat(point.querySelector('X')?.textContent.trim()), y: parseFloat(point.querySelector('Y')?.textContent.trim()) }
                        }
                      })

                      let actualCorners = zonePoints.filter(function (el) {
                        return el != null;
                      });

                      return {
                        velocity: parseFloat(zone.querySelector('Velocity')?.textContent.trim()),
                        beep: zone.querySelector('Beep')?.textContent.trim() === 0 ? false : true,
                        name: zone.querySelector('Name')?.textContent.trim(),
                        polygon: actualCorners
                      }
                    })

                    console.log('zones are ', navZones)
                    areas = navZones
                    //context.actions.setSelected({ ...context.selected, map: { objects: info } })

                    console.log('fetching no go info from xml...')

                    fetch('http://' + context.selectedRobot.ip + '/no_go_Info.xml?nocache=' + Date.now())
                      .then(response => {
                        response.text()
                          .then(info => {
                            const xmlDoc = new DOMParser().parseFromString(info, 'text/xml')

                            const noGoZones = [...xmlDoc.querySelectorAll('nogoZone > *')].map((zone, i) => {
                              const zonePoints = [...xmlDoc.querySelectorAll(`Polygon${i} > *`)].map((point, j) => {
                                if (point.querySelector('X') && point.querySelector('Y')) {
                                  return {
                                    counter: 'pf-' + i + '-' + j,
                                    point: { x: parseFloat(point.querySelector('X')?.textContent.trim()), y: parseFloat(point.querySelector('Y')?.textContent.trim()) }
                                  }
                                } else return null
                              })

                              let actualCorners = zonePoints.filter(function (el) {
                                return el != null;
                              });

                              return {
                                polygon: actualCorners
                              }
                            })

                            console.log('no gos are ', noGoZones, context.mapObjects)
                            no_go = noGoZones
                            //context.actions.setSelected({ ...context.selected, map: { objects: info } })

                            console.log(points, edges, areas, no_go)
                            context.actions.setMapObjects({ points: points, edges: edges, areas: areas, no_go: no_go })
                          })
                      })
                      .catch(error => {
                        console.error(error)
                      })
                  })
              })
              .catch(error => {
                console.error(error)
              })
          })
      })
      .catch(error => {
        console.error(error)
      })
  }

  useEffect(() => {
    if (!isMapping) {
      if (context.settings.fmsConnection) {
        fetchMaps()

        console.log(context.maps, context.robotInfo?._id)

        let actualMaps = context.maps.map((m, i) => {
          //context.selectedRobot não tem ID para comparar ao m.robotId
          if (m.robotId === context.robotInfo?._id) {
            return m
          } else return null
        })

        console.log(actualMaps)

        let deleteNulls = actualMaps.filter(function (el) {
          return el != null;
        });

        console.log(deleteNulls, context.mapIndex)

        if (deleteNulls.length > 0) {
          console.log('fetching map name from txt...')

          fetch('http://' + context.selectedRobot.ip + '/map.txt?nocache=' + Date.now())
            .then(response => {
              response.text()
                .then(text => {
                  console.log('map name is ', text)
                  let noSpacing = text.replace(/\n/g, '')
                  let index = deleteNulls.findIndex(m => m.name === noSpacing)
                  if (index === -1) {
                    context.actions.setMessage({ message: "Current map mismatch. Please select a map.", type: "error" })
                    context.actions.setSelected({ map: { name: "Select map" } })
                    return false
                  }
                  context.actions.setSelected({ ...context.selected, map: { name: noSpacing, robotId: context.robotInfo._id } })
                  context.actions.setHelpers({ ...context.helpers, newItem: true })
                  setIsMapping((context.mappingCurrent && context.mappingCurrent.name === deleteNulls[index].name) ? context.mappingCurrent?.mapping : false)
                  context.actions.setMapObjects(deleteNulls[index].objects ? deleteNulls[index].objects : {})

                  let maps = deleteNulls.map(m => m.robotId === context.robotInfo?._id && m.name === deleteNulls[index].name ?
                    ({ ...m, active: true })
                    : m.robotId === context.robotInfo?._id ?
                      ({ ...m, active: false })
                      :
                      (m))

                  console.log(maps)
                  context.actions.setMaps(maps)

                  if (~index) {
                    !deleteNulls[index]?.robotId && addRobotId(context.robotInfo?._id, index)
                  }

                  console.log(maps[index].name)

                  if (context.endOfMission) sendTaskToRobot({ actions: [{ id: "select-map", name: "select-map", value: maps[index].name }], id: "select-map", name: "select-map" }, context.selectedRobot.ROS)

                  console.log("init map index and selected", index, deleteNulls[index])
                  context.actions.setMapIndex(index)
                })
            })
            .catch(error => {
              console.error(error)
            })
        }
      } else {
        fetchMapInformation()
          .then(() => {
            console.log('yo', context.mapFeedFull)
            if (Object.keys(context.mapFeedFull).length > 0) {
              console.log('setting offline map...', context.mapObjects)
              context.actions.setMaps([{ name: context.selected?.map?.name, _id: 1, objects: context.mapObjects, link: '/maps/' + context.selected?.map?.name + '.png', origin: context.mapFeedFull.origin.position, resolution: context.mapFeedFull.resolution }])
            }
          })
      }
    }

    if (canvas) {
      //console.log("subscribing to map")
      window.mapSubscriber = ROS.subscribeMap(callback, canvas, context, false)
    }

  }, [context.robotInfo?._id])

  useEffect(() => {
    if (!context.settings.fmsConnection && !isMapping && (context.endOfMission || (context.lastMission !== 'map' && context.lastMission !== 'soft-map'))) {
      fetchMapInformation()
        .then(() => {
          console.log('yo', context.mapFeedFull)
          if (Object.keys(context.mapFeedFull).length > 0) {
            console.log('setting offline map...', context.mapObjects)
            context.actions.setMaps([{ name: context.selected?.map?.name, _id: 1, objects: context.mapObjects, link: '/maps/' + context.selected?.map?.name + '.png', origin: context.mapFeedFull.origin.position, resolution: context.mapFeedFull.resolution }])
          }
        })
    }
  }, [context.mapFeedFull])

  const addRobotId = (robotId, indexMap) => {

    if (robotId && indexMap) {
      let maps = [...context.maps]

      const newMap = { ...context.maps[indexMap], robotId: robotId }
      maps[context.mapIndex] = newMap

      context.actions.setMaps(maps)
    }

  }

  // select new tool ----------------------------------------------------------------------------

  const selectTool = (target) => {
    context.actions.setHelpers({ ...context.helpers, newItem: true })
    setModalData(null)
    const tool = target === '' ? null : context.drawTools.find(map => map._id === target)
    console.log("selecting tool", tool)
    if (tool) context.actions.setSelected({ tool: tool, connect: null })
  }

  // save zone info -------------------------------------------------------------------------

  const saveZoneInfo = () => {
    setModal(false)
  }

  // validate zone data (close objects) ----------------------------------------------------------------------------

  const validateZone = () => {

    let newObjects = { ...context.mapObjects }

    newObjects.areas && newObjects.areas.forEach((zone, idx) => {
      if (Array.isArray(zone.points) && zone.points[0] !== zone.points[zone.points.length - 1])
        newObjects.areas[idx].points.push(zone.points[0])
    })

    context.actions.setMapObjects(newObjects)
  }

  const nameChecker = (name) => {
    let savedNames

    if (context.selectedRect) {
      savedNames = new Set(context.konvaZones.map(zone => zone.name))
    } else {
      savedNames = new Set(context.konvaPoints.map(point => point.name))
    }

    console.log(savedNames, name)

    let newName = name
    let counter = 1

    while (savedNames.has(newName)) {
      newName = name + counter
      counter++
    }

    return newName
  }

  // undo -----------------------------------------------------------------------------------------------------
  const undo = () => {
    if (context.changes.length > 0) {
      context.actions.setKonvaPoints([...context.changes[context.changes.length - 1].old[0]])
      context.actions.setKonvaEdges([...context.changes[context.changes.length - 1].old[1]])
      context.actions.setKonvaZones([...context.changes[context.changes.length - 1].old[2]])

      console.log(context.changes)
      let newChanges = [...context.changes]
      context.actions.setUndone([...context.undone, newChanges.pop()])

      context.actions.setChanges([...newChanges])

      context.actions.setSelector(false)
    }
  }

  const redo = () => {
    if (context.undone.length > 0) {
      context.actions.setKonvaPoints([...context.undone[context.undone.length - 1].new[0]])
      context.actions.setKonvaEdges([...context.undone[context.undone.length - 1].new[1]])
      context.actions.setKonvaZones([...context.undone[context.undone.length - 1].new[2]])

      context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaZones], new: [context.undone[context.undone.length - 1].new[0], context.undone[context.undone.length - 1].new[1], context.undone[context.undone.length - 1].new[2]] }])

      console.log(context.undone)
      let newUndone = [...context.undone]
      newUndone.pop()

      context.actions.setUndone(newUndone)

      context.actions.setSelector(false)
    }
  }

  const copy = () => {
    let pointsToCopy, pointNames = [], edgesToCopy = []
    if (context.selectedShapes.length > 0) {
      pointsToCopy = context.selectedShapes.map(shape => {
        pointNames.push(shape.attrs.name)

        let newName = nameChecker(shape.attrs.name)

        return {
          ...shape.attrs,
          name: newName,
          scaleX: 1,
          scaleY: 1,
          x: shape.attrs.x + 15,
          y: shape.attrs.y - 15
        }
      })

      context.konvaEdges.forEach(edge => {
        if (pointNames.some(point => point === edge.pointIds[0]) && pointNames.some(point => point === edge.pointIds[1])) {
          let firstIndex = context.selectedShapes.findIndex(shape => shape.attrs.name === edge.pointIds[0])
          let lastIndex = context.selectedShapes.findIndex(shape => shape.attrs.name === edge.pointIds[1])

          edgesToCopy.push({
            ...edge,
            name: pointsToCopy[firstIndex].name + ' a ' + pointsToCopy[lastIndex].name,
            pointIds: [pointsToCopy[firstIndex].name, pointsToCopy[lastIndex].name],
            points: [edge.points[0] + 5, edge.points[1] - 5, edge.points[2] + 5, edge.points[3] - 5]
          })
        }
      })

      context.actions.setPointCopy(pointsToCopy)
      context.actions.setEdgeCopy(edgesToCopy)

      context.actions.setMessage({ message: "Copied points to clipboard!", type: "success" })
    } else if (context.pointClickState && context.shapeRef) {
      console.log(context.shapeRef)

      let newName = nameChecker(context.shapeRef.attrs.name)

      context.actions.setPointCopy([{
        ...context.shapeRef.attrs,
        name: newName,
        scaleX: 1,
        scaleY: 1,
        x: context.shapeRef.attrs.x + 15,
        y: context.shapeRef.attrs.y - 15
      }])


      context.actions.setMessage({ message: "Copied point to clipboard!", type: "success" })
    } else if (context.selectedRect) {
      console.log(context.selectedRect)

      let newName = nameChecker(context.selectedRect.name)

      context.actions.setZoneCopy([{
        ...context.selectedRect,
        name: newName,
        scaleX: 1,
        scaleY: 1,
        x: context.shapeRef.attrs.x + 20,
        y: context.shapeRef.attrs.y - 20
      }])

      context.actions.setMessage({ message: "Copied zone to clipboard!", type: "success" })
    }

    console.log('COPYING: ', pointsToCopy, edgesToCopy)
  }

  const paste = () => {
    let pastedPoints, pastedEdges
    if (context.pointCopy.length > 0) {
      pastedPoints = context.konvaPoints.concat(context.pointCopy)
      context.actions.setKonvaPoints(pastedPoints)

      if (context.edgeCopy.length > 0) {
        pastedEdges = context.konvaEdges.concat(context.edgeCopy)
        context.actions.setKonvaEdges(pastedEdges)
      } else {
        pastedEdges = context.konvaEdges
      }

      context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaZones], new: [pastedPoints, pastedEdges, context.konvaZones] }])
      context.actions.setUndone([])
      context.actions.setPointCopy([])
      context.actions.setPasted(context.pointCopy)

      console.log('PASTING: ', pastedPoints, pastedEdges)
    } else if (context.zoneCopy.length > 0) {
      const pastedZones = context.konvaZones.concat(context.zoneCopy)
      context.actions.setKonvaZones(pastedZones)

      context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaZones], new: [context.konvaPoints, context.konvaEdges, pastedZones] }])
      context.actions.setUndone([])
      context.actions.setZoneCopy([])
    }
  }

  const validatePointName = (name) => {

    let names = []

    if (context.mapObjects?.points) {
      context.mapObjects.points.forEach(e => {
        names = names.concat(e.name)
      })
    }

    return names.includes(name)

  }
  const validatePoint = name => validatePointName(name)

  // connect points -------------------------------------------------------------------------------------

  const connect = (pointData) => {

    if (!modalData?.name) {
      context.actions.setMessage({ message: "Please add an ID", type: "error" })
      return false
    }

    setModal(null)
    console.log("connecting points from", pointData.name[0])
    context.actions.setSelected({ connect: { from: pointData.name[0] } })
  }

  // cancel connect ----------------------------------------------------------------------------------------

  const cancelConnect = () => {
    context.actions.setSelected({ connect: null })
    if (context.selected.tool._id !== "points") context.actions.setHelpers({ ...context.helpers, newItem: true })
  }

  // save edge -----------------------------------------------------------------------------------

  const saveEdge = () => {
    setModal(null)
    context.actions.setHelpers({ ...context.helpers, editing: false })
    context.actions.setSelected({ connect: null })
  }

  // delete object ---------------------------------------------------------------------------------------

  const deleteObject = () => {

    let newObjects = { ...context.mapObjects }, newEdges

    switch (context.selected.mapObject?.type) {
      case "points":
        let deletedPoint = newObjects.points[context.selected.mapObject.idx]
        newObjects.points.splice(context.selected.mapObject.idx, 1)
        // console.log("delete: new points", newObjects.points, context.selected.mapObject)

        // remove connected edges, if present
        newEdges = newObjects.edges.filter(edge => deletedPoint.name.indexOf(edge.from) < 0 && deletedPoint.name.indexOf(edge.to) < 0)

        newObjects.edges = newEdges
        // console.log("delete: new edges", newEdges, deletedPoint)
        break
      case "edges":
        newObjects.edges.splice(context.selected.mapObject.idx, 1)
        // console.log("delete: new edges", newObjects.edges, context.selected.mapObject)
        break
      case "areas":
        newObjects.areas.splice(context.selected.mapObject.idx, 1)
        // console.log("delete: new zones", newObjects.areas, context.selected.mapObject)
        break
      default:
    }

    context.actions.setSelected({ mapObject: null, connect: null })
    setModalData(null)
    context.actions.setMapObjects(newObjects)
    context.actions.setHelpers({ ...context.helpers, editing: false })
    setModal(null)
  }

  //-------------------------------

  const toggleAutoSave = () => {
    if (autoSave) {
      setAutoSave(false)
    } else {
      setAutoSave(true)
    }
  }

  //-------------------------------

  const tracePolygon = (start, visitedEdges, adjacencyList) => {
    let polygon = []
    let current = start

    while (1) {
      polygon.push(current)
      let neighbors = adjacencyList[current]

      let next = neighbors.find(neighbor => !visitedEdges.has(edgeKey(current, neighbor)))

      if (!next) break

      visitedEdges.add(edgeKey(current, next))
      visitedEdges.add(edgeKey(next, current))

      current = next

      if (current === start) {
        polygon.push(current)
        break
      }
    }

    return polygon
  }

  const edgeKey = (a, b) => {
    return a + '-' + b
  }

  // modal toggling -------------------------------------------------------------------------------

  let modalTitle, modalButtonLabel, modalButtonAction, modalComponent

  switch (modal) {
    case "reset": {
      if (context.selected.map) {
        modalTitle = "Reset Items"
        modalButtonLabel = "Reset"
        modalButtonAction = resetMap
        modalComponent = <ModalReset />
      } else {
        context.actions.setMessage({ message: "Select a map first", type: "error" })
        closeModal()
      }
      break
    }
    case "areas": {
      modalTitle = "Zone"
      modalButtonLabel = "Save"
      modalButtonAction = savePoint
      modalComponent = <ModalArea velocity={modalData?.velocity} beep={modalData?.beep} update={updateModalData} />
      break
    }
    case "map": {
      modalTitle = "Map Name"
      modalButtonLabel = "Save"
      modalButtonAction = saveMap
      modalComponent = <ModalMap mapName={modalData?.mapName} update={updateModalData} />
      break
    }
    case "soft-map": {
      saveMapImprove()
      break
    }
    case "delete": {
      modalTitle = "Delete Map"
      modalButtonLabel = "Yes"
      modalButtonAction = deleteMap
      modalComponent = <ModalDelete mapName={context.selected.map?.name} />
      break
    }
    case "points": {
      modalTitle = "Point"
      modalButtonLabel = "Save"
      modalButtonAction = savePoint
      modalComponent = <ModalPoint pointData={modalData} update={updateModalData} connect={connect} validatePointName={validatePoint} />
      break
    }
    case "location": {
      modalTitle = "Point"
      modalButtonLabel = "Save"
      modalButtonAction = savePoint
      modalComponent = <ModalPoint pointData={modalData} update={updateModalData} connect={connect} validatePointName={validatePoint} />
      break
    }
    case "edges": {
      modalTitle = "Edge"
      modalButtonLabel = "Save"
      modalButtonAction = saveEdge
      //("detected edge modal")
      modalComponent = <ModalEdge edgeData={modalData} update={updateModalData} />
      break
    }
    case "sync": {
      modalTitle = "Sync Preview - Confirmação"
      modalButtonLabel = "Confirmar e Enviar"
      modalButtonAction = confirmSync
      modalComponent = <ModalSyncPreview syncPreview={syncPreview} formatPointValue={formatPointValue} formatEdgeLabel={formatEdgeLabel} />
      break
    }
    case "profile": {
      modalTitle = 'New Profile'
      modalButtonLabel = 'Confirmar'
      modalButtonAction = saveProfile
      modalComponent = (
        <div>
          <p className="mb-3">
            O profile inicial sera salvo automaticamente como Default. Informe o nome do novo profile para criar um conjunto separado.
          </p>
          <div className="field">
            <label className="label">Nome do Profile</label>
            <div className="control">
              <input
                className="input"
                type="text"
                value={modalData?.profileName || ''}
                onChange={(event) => updateModalData('profileName', event.target.value)}
                placeholder="Ex: Expedicao"
              />
            </div>
          </div>
        </div>
      )
      break
    }
    default:
  }

  // helpers ------------------------------------------------------------------------------------

  let tool = context.selected.tool?._id

  return (
    <>

      {/* Top Actions */}

      <div className="mb-5">
        <span>
          {context.settings.fmsConnection &&
            <div className="select">
              <select className="select mb-2 mr-2" onChange={selectMap} value={context.selected.map?.name} style={{ minHeight: "2.5rem" }} disabled={isMapping || context.loadingMap || !context.endOfMission} >
                <option value='Select map' disabled>Select map</option>
                {context.maps.map((m, i) =>
                  m.robotId === context.robotInfo?._id &&
                  <option key={i} value={m?.name}>
                    {m?.name?.length >= 15 ? m?.name?.slice(0, 12) + "..." : m?.name?.slice(0, 14)}
                  </option>
                )}
              </select>
            </div>
          }

          {!context.settings.fmsConnection && context.selected.map && !isMapping &&
            <div className="column">
              <p className="pt-2">
                Selected map: {context.selected.map.name}
              </p>
            </div>
          }

          {!context.settings.fmsConnection && context.selected.map && isMapping &&
            <div className="column">
              <p className="pt-2">
                Currently mapping to: {modalData?.mapName}
              </p>
            </div>
          }

          {!isMapping && !context.savingStatus ? (
            <>
              <button disabled={!context.endOfMission} className="button is-primary mr-2" onClick={() => toggleMapping("map")}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faMapMarked} className="is-small mr-1" />
                </span>
                {orientation &&
                  <span className="is-size-7" >New Map</span>
                }
              </button>

              <button disabled={!context.endOfMission} className={context.selected.map && context.selected.map.name && (context.selected.map.name !== "Select map") ? "button is-primary is-outlined mr-2" : "button is-hidden"} onClick={() => toggleMapping("soft-map")}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faCirclePlus} className="is-small" />
                </span>
                {orientation &&
                  <span className="is-size-7" >Improve Map</span>
                }
              </button>

              <button
                disabled={!context.endOfMission}
                className={context.selected.map && context.selected.map.name && (context.selected.map.name !== "Select map") ? "button is-danger " : "button is-hidden"}
                onClick={() => openModal("delete")}
              >
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faTrash} className="is-small" />
                </span>
                {orientation &&
                  <span className="is-size-7" >Delete Map</span>
                }
              </button>

              {context.settings.fmsConnection &&
                <button disabled={!context.endOfMission} className={
                  autoSave
                    ? "button is-success ml-2"
                    : "button has-background-light is-active ml-2"
                } onClick={toggleAutoSave} style={{ float: 'right' }}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faSave} className={
                      autoSave
                        ? "is-small mr-1 fa-spin"
                        : "is-small mr-1"
                    } />
                  </span>
                  <span className="is-size-7">Auto Sync {autoSave ? 'On' : 'Off'}</span>
                </button>
              }

              {context.settings.fmsConnection && !autoSave &&
                <button disabled={!context.endOfMission} className="button is-warning is-light ml-2" onClick={openSyncModal} onTouchEnd={openSyncModal} style={{ float: 'right' }}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faRetweet} className="is-small mr-1" />
                  </span>
                  <span className="is-size-7">Sync to FMS</span>
                </button>
              }

              {context.settings.fmsConnection && !autoSave &&
                <span style={{ float: 'right', display: 'flex', gap: '0.5rem', marginLeft: '0.5rem' }}>
                  <button
                    disabled={!context.endOfMission || !context.selected.map || context.selected.map.name === 'Select map'}
                    className="button is-info is-light"
                    onClick={openProfileModal}
                    onTouchEnd={openProfileModal}
                  >
                    <span className="icon is-small">
                      <FontAwesomeIcon icon={faMapSigns} className="is-small mr-1" />
                    </span>
                    <span className="is-size-7">New Profile</span>
                  </button>

                  <div className="select is-info is-light">
                    <select
                      disabled={!context.endOfMission || !context.selected.map || context.selected.map.name === 'Select map' || getProfileNames(getCurrentMapItem()).length === 0}
                      onChange={selectProfile}
                      value={selectedProfileName || ''}
                      style={{ minHeight: '2.5rem', minWidth: '10rem' }}
                    >
                      {getProfileNames(getCurrentMapItem()).length === 0 &&
                        <option value="">Sem profiles</option>
                      }
                      {getProfileNames(getCurrentMapItem()).map((profileName) => (
                        <option key={profileName} value={profileName}>
                          {profileName}
                        </option>
                      ))}
                    </select>
                  </div>
                </span>
              }
            </>
          ) : (
            <>
              {context.savingStatus ? (
                <button className="button is-danger mr-2" disabled>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faSave} className="fas fa-pulse is-small" />
                  </span>
                  {orientation &&
                    <span className="is-size-7" > Saving </span>
                  }
                </button>
              ) : (
                <button disabled={!context.endOfMission && !(context.lastMission === 'map' || context.lastMission === 'soft-map')} className="button is-danger mr-2" onClick={() => toggleMapping("map")}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faCheck} className="is-small" />
                  </span>
                  {orientation &&
                    <span className="is-size-7" > Stop </span>
                  }
                </button>
              )}

            </>
          )
          }
        </span>

      </div>

      {/* Joystick */}

      {(isMapping && modal !== "map" && !context.modalState.disconnect && !context.modalState.configuration) &&
        <div className="column has-text-white-bis">

          {/* <div className="columns is-centered">
            <div className="column has-background-info-light is-narrow">
              <button className="button is-primary" onClick={handSelected}>
                <span className="icon is-small">
                  <i className="material-icons-round">{!hand ? "pan_tool" : "pan_tool"}</i>
                </span>
                <span>{!hand ? "Right" : "Left"}</span>
              </button>
            </div>
          </div> */}

          <Joystick orientation={orientation} />
        </div>
      }

      {/* Map */}

      <div className="has-background-grey" style={{ width: "100%", height: "36rem", position: "relative" }} id='canvas-id' ref={canvasRef} >

        {/*<canvas id='canvas-id' ref={canvasRef}>*/}
        <Suspense fallback={null}>
          <MapCanvas
            canvasRef={canvasRef}
            openModal={openModal}
            modalData={(modal === "nav" || modal === "area" || modal === "point") && modalData}
            context={context}
            updateCanvas={(c) => setCanvas(c)}
          />
        </Suspense>
        {/*</canvas>*/}

        {/* Tools */}

        {!context.loadingMap &&
          <div id="tools" style={{ position: "absolute", top: "1rem", left: "1rem" }}>
            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'select' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('select')}>
              <FontAwesomeIcon icon={faArrowPointer} className="is-small mr-2" />
              <span className="is-size-7">Select</span>
            </button>

            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'points' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('points')}>
              <FontAwesomeIcon icon={faLocationArrow} className="is-small mr-2" />
              <span className="is-size-7">Route</span>
            </button>

            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'zones' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('zones')}>
              <FontAwesomeIcon icon={faVectorSquare} className="is-small mr-2" />
              <span className="is-size-7">Zone</span>
            </button>

            <button className={context.selected.tool?._id === 'location' ? "button has-background-warning mr-2" : "button is-outlined mr-2"} onClick={() => locateRobot()} disabled={tool === 'select' || tool === 'no_go' || tool === 'zones' || !context.endOfMission} >
              <FontAwesomeIcon icon={faMapPin} className="is-small mr-2" />
              <span className="is-size-7">Here</span>
            </button>

            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'show' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('show')}>
              <FontAwesomeIcon icon={faCircleDot} className="is-small mr-2" />
              <span className="is-size-7">Show All</span>
            </button>

            {context.selected.connect &&
              <button disabled={!context.endOfMission} className="button is-link is-focused" onClick={cancelConnect}>
                Cancel Connect
              </button>
            }

          </div>
        }

        {/*Loading map */}

        {context.loadingMap &&

          <div id="tools" style={{ position: "absolute", top: "50%", width: "100%", textAlign: "center" }}>
            <button className="button is-primary mr-2" disabled>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faSpinner} className="fas fa-pulse is-small" />
              </span>
              {orientation &&
                <span className="is-size-7" > Loading </span>
              }
            </button>
          </div>
        }

        {/* Actions */}

        {!context.loadingMap &&
          <div id="actions" style={{ position: "absolute", bottom: "1rem", left: "1rem" }}>
            {(!modal) && (context.pointCopy.length > 0 || context.zoneCopy.length > 0) && context.selected.tool._id !== 'show' &&
              <span className="is-pulled-right" style={{ marginRight: "0.5rem" }}>
                <button disabled={!context.endOfMission} className="button is-info is-outlined" onClick={paste}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faPaste} className="is-small mr-1" />
                  </span>
                  {orientation &&
                    <span className="is-size-7">Paste</span>
                  }
                </button>
              </span>
            }

            {(!modal) && (context.selectedShapes.length > 0 || (context.pointClickState && context.shapeRef) || context.selectedRect) && context.selected.tool._id !== 'show' &&
              <span className="is-pulled-right" style={{ marginRight: "0.5rem" }}>
                <button disabled={!context.endOfMission} className="button is-info is-outlined" onClick={copy}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faCopy} className="is-small mr-1" />
                  </span>
                  {orientation &&
                    <span className="is-size-7">Copy</span>
                  }
                </button>
              </span>
            }

            {(!modal) && context.undone.length > 0 &&
              <span className="is-pulled-right" style={{ marginRight: "0.5rem" }}>
                <button disabled={!context.endOfMission} className="button is-success is-outlined" onClick={redo}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faShare} className="is-small mr-1" />
                  </span>
                  {orientation &&
                    <span className="is-size-7">Redo</span>
                  }
                </button>
              </span>
            }

            {(!modal) && context.changes.length > 0 &&
              <span className="is-pulled-right" style={{ marginRight: "0.5rem" }}>
                <button disabled={!context.endOfMission} className="button is-danger is-outlined" onClick={undo}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faReply} className="is-small mr-1" />
                  </span>
                  {orientation &&
                    <span className="is-size-7">Undo</span>
                  }
                </button>
              </span>
            }

            <button disabled={!context.endOfMission} className="button is-success" onClick={save} style={{ marginRight: "0.5rem" }}>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faSave} className="is-small" />
              </span>
              {orientation &&
                <span className="is-size-7">Send to Robot</span>
              }
            </button>

            <button disabled={!context.endOfMission} className="button is-danger" onClick={() => openModal("reset")} style={{ marginRight: "0.5rem" }}>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faUndo} className="is-small mr-1" />
              </span>
              {orientation &&
                <span className="is-size-7 has-text-white">Clear All</span>
              }
            </button>
          </div>
        }
      </div>


      {/* Message */}

      <ShowMessage />

      {/* Modal */}

      <div id="modal" className={modal ? "modal is-active" : "modal"} ref={modalRef}>
        <div className="modal-background"></div>
        <div className="modal-card">

          <header className="modal-card-head">
            <p className="modal-card-title">
              {modalTitle}
            </p>
            <button disabled={!context.endOfMission} className="delete" onClick={closeModal} aria-label="close"></button>
          </header>

          <section className="modal-card-body">

            {modal && modalComponent}

            <ShowMessage />

          </section>

          <footer className="modal-card-foot">
            {modalButtonLabel !== 'Reset' &&
              <button disabled={!context.endOfMission} className="button is-success" onClick={modalButtonAction}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faSave} className="is-small" />
                </span>
                <span>
                  {modalButtonLabel}
                </span>
              </button>
            }

            {modalButtonLabel === 'Reset' &&
              <button disabled={!context.endOfMission} className="button is-danger" onClick={modalButtonAction}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faUndo} className="is-small" />
                </span>
                <span>
                  {modalButtonLabel}
                </span>
              </button>
            }

            {context.helpers.editing &&
              <button disabled={!context.endOfMission} className="button is-danger" onClick={deleteObject} style={{ marginRight: "0.5rem" }}>
                Delete
              </button>
            }

            <button disabled={!context.endOfMission} className="button" onClick={closeModal}>
              Cancel
            </button>

          </footer>

        </div>
      </div>
    </>
  )
}
